var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIconNoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6V11.25M5.5 6V11.25M2.5 3V11.85C2.5 12.6901 2.5 13.1098 2.66349 13.4307C2.8073 13.7129 3.0366 13.9429 3.31885 14.0867C3.6394 14.25 4.05925 14.25 4.89768 14.25H9.10232C9.94075 14.25 10.36 14.25 10.6805 14.0867C10.9628 13.9429 11.1929 13.7129 11.3367 13.4307C11.5 13.1101 11.5 12.6908 11.5 11.8523V3M2.5 3H4M2.5 3H1M4 3H10M4 3C4 2.30109 4 1.9518 4.11418 1.67615C4.26642 1.30861 4.55824 1.01642 4.92578 0.864181C5.20144 0.75 5.55109 0.75 6.25 0.75H7.75C8.44891 0.75 8.79837 0.75 9.07402 0.864181C9.44157 1.01642 9.7335 1.30861 9.88574 1.67615C9.99992 1.9518 10 2.30109 10 3M10 3H11.5M11.5 3H13",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIconNoColor);
export default __webpack_public_path__ + "static/media/removeIconNoColor.c48685d6a578a7153a9fa6f7730d280a.svg";
export { ForwardRef as ReactComponent };